import React from 'react';

export default function FilterSidebar({ filters, onFilterChange }) {
  const { price, minRating, format } = filters;

  const handlePriceChange = (e) => onFilterChange('price', e.target.value);
  const handleRatingChange = (e) => onFilterChange('minRating', e.target.value);
  
  const handleFormatChange = (e) => {
    const newFormat = e.target.value;
    const currentFormats = format ? format.split(',') : [];
    if (e.target.checked) {
      onFilterChange('format', [...currentFormats, newFormat].join(','));
    } else {
      const updated = currentFormats.filter(f => f !== newFormat).join(',');
      onFilterChange('format', updated || null);
    }
  };

  const formats = ['PSD', 'AI', 'FIG', 'INDD', 'PDF'];

  return (
    <div className="filter-sidebar" style={{ 
      padding: '24px', 
      backgroundColor: 'var(--bg-elevated)', 
      borderRadius: '16px', 
      border: '1px solid var(--border-subtle)',
      display: 'flex',
      flexDirection: 'column',
      gap: '24px'
    }}>
      <div>
        <h3 style={{ fontWeight: 600, marginBottom: '16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          Filters
          {(price || minRating || format) && (
            <button 
              onClick={() => onFilterChange('clear', null)}
              style={{ fontSize: '12px', color: 'var(--primary-color)', background: 'none', border: 'none', cursor: 'pointer' }}
            >
              Clear All
            </button>
          )}
        </h3>
      </div>

      <div>
        <h4 style={{ fontSize: '14px', fontWeight: 600, marginBottom: '12px', color: 'var(--text-secondary)' }}>Price</h4>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
            <input type="radio" name="price" value="" checked={!price} onChange={handlePriceChange} />
            <span style={{ fontSize: '14px' }}>All</span>
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
            <input type="radio" name="price" value="free" checked={price === 'free'} onChange={handlePriceChange} />
            <span style={{ fontSize: '14px' }}>Free</span>
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
            <input type="radio" name="price" value="premium" checked={price === 'premium'} onChange={handlePriceChange} />
            <span style={{ fontSize: '14px' }}>Premium</span>
          </label>
        </div>
      </div>

      <div>
        <h4 style={{ fontSize: '14px', fontWeight: 600, marginBottom: '12px', color: 'var(--text-secondary)' }}>Rating</h4>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
            <input type="radio" name="rating" value="" checked={!minRating} onChange={handleRatingChange} />
            <span style={{ fontSize: '14px' }}>Any Rating</span>
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
            <input type="radio" name="rating" value="4" checked={minRating === '4'} onChange={handleRatingChange} />
            <span style={{ fontSize: '14px' }}>4+ Stars</span>
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
            <input type="radio" name="rating" value="3" checked={minRating === '3'} onChange={handleRatingChange} />
            <span style={{ fontSize: '14px' }}>3+ Stars</span>
          </label>
        </div>
      </div>

      <div>
        <h4 style={{ fontSize: '14px', fontWeight: 600, marginBottom: '12px', color: 'var(--text-secondary)' }}>Format</h4>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {formats.map(fmt => (
            <label key={fmt} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input 
                type="checkbox" 
                value={fmt} 
                checked={format ? format.split(',').includes(fmt) : false} 
                onChange={handleFormatChange} 
              />
              <span style={{ fontSize: '14px' }}>{fmt}</span>
            </label>
          ))}
        </div>
      </div>

    </div>
  );
}
